export default {
    state: {
        user: {}
    },
    mutations: {
        async setUser(state, data) {
            state.user = data
        }
    }
}